const epochToIsoDate = (epoch: number, showHour?: boolean) => {
  const isoString = new Date(epoch).toISOString();
  return showHour ? isoString : isoString.substring(0, isoString.indexOf('T'));
};

export default epochToIsoDate;
